import React, { useEffect } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  InputNumber,
  Cascader,
  TreeSelect,
  Button,
  Checkbox,
  Radio,
  Upload,
  message
} from "antd";
import "./Ant-FormBuilder.scss";
// import ReactTooltip from "react-tooltip";
// import SVGIcon from "../SVGIcon/SVGIcon";
import moment from "moment";
import "moment/locale/zh-cn";
import { UploadOutlined } from '@ant-design/icons';
// import { DEPLOYED_ENVIRONMENT, ENVIRONMENTS } from "../../../Environments/environments";
import { API_ENDPOINTS } from "../../../Environments/config";

// Form supports fields of type
// 1. Text
// 2. TextArea
// 3. Number
// 4. Password
// 5. Single Select
// 6. Multi Select
// 7. Cascader
// 8. TreeSelect
// 9. DatePicker
// 10. Checkbox
// 11. Radio

export default function FormBuilder({ config, onAction, data, id, ...props }) {
  const [form] = Form.useForm();
  const { SHOW_CHILD } = Cascader;
  const formLayout = "vertical";
  const { TextArea } = Input;
  useEffect(() => {
    if (data) {
      let tempData = JSON.parse(JSON.stringify(data));
      let formData = {};
      config.map((row) =>
        row.map((el) => {
          if (el?.key === "fielding_end_date") {
            if (tempData?.fielding_end_date) {
              formData.fielding_end_date = moment(tempData?.fielding_end_date);
            }
          } else if (el?.key === "fielding_start_date") {
            if (tempData?.fielding_start_date) {
              formData.fielding_start_date = moment(
                tempData?.fielding_start_date
              );
            }
          } else if (el.key) {
            formData[el.key] = tempData[el.key];
          }
        })
      );
      form.setFieldsValue({ ...formData });
    }
  }, [data]);

  /**
   * On input value changes
   * @param {*} e - change event
   * @param {*} field - form field
   */
  const onSelectChange = (e, field) => {
    try {
      if (field?.key === "project_code_id") {
        let clientName = "";
        field?.options.map((option) => {
          if (option?.value === e) {
            clientName = option?.client_name;
          }
        });
        let tempData = data;
        tempData["project_code_id"] = e;
        tempData["client_name"] = clientName;
        form.setFieldsValue({ ...tempData });
        const payload = {
          key: "project_code_id",
          value: e,
        };
        payload["data"] = { ...tempData };
        if (typeof onAction === "function")
          onAction({ type: "onChange", payload });
      } else if (field?.key === "fielding_start_date") {
        let startDate = form.getFieldValue("fielding_start_date");
        let endDate = form.getFieldValue("fielding_end_date");
        if (startDate && endDate) {
          let tempData = data;
          tempData["fielding_start_date"] = startDate;
          tempData["fielding_end_date"] = endDate;
          let diff = moment(endDate) - moment(startDate);
          if (diff / (1000 * 60 * 60 * 24) < 0) {
            form.setFieldsValue({ fielding_end_date: "" });
            tempData["fielding_end_date"] = "";
          }
        }
      } else if (field?.key === "fielding_end_date") {
        let startDate = form.getFieldValue("fielding_start_date");
        let endDate = form.getFieldValue("fielding_end_date");
        if (startDate && endDate) {
          let tempData = data;
          tempData["fielding_start_date"] = startDate;
          tempData["fielding_end_date"] = endDate;
          let diff = moment(endDate) - moment(startDate);
          if (diff / (1000 * 60 * 60 * 24) < 0) {
            form.setFieldsValue({ fielding_start_date: "" });
            tempData["fielding_start_date"] = "";
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const onFormLayoutChange = (changedValues, allValues) => {
    const payload = {};
    payload["data"] = { ...data, ...changedValues };
    if (typeof onAction === "function") onAction({ type: "onChange", payload });
  };

  /**
   * Finish event of form
   * @param {*} formData - form data
   */
  const onFinish = (formData) => {
    let errors = {}
    config[0]?.map((el) => {
      if (data?.[el?.key]?.length === 0) {
        errors[el?.key] = 'error'
      }
    })
    if (Object.keys(errors).length === 0) {
      try {
        const payload = {
          data: formData,
        };
        if (typeof onAction === "function") onAction({ type: "submit", payload });
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const uploadProps = {
    name: 'file',
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info, info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`,3);

      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`,3);
      }
    }
  }

  return (
    <Form
      id={id}
      form={form}
      layout={formLayout}
      onFinish={onFinish}
      onValuesChange={onFormLayoutChange}
      className="form-builder"
      name={id}
    >
      {config?.map((list, i) => {
        return (<Row id={i} className="form-row">
          {list?.map((field, i) => {
            return (
              <Col span={field?.col} >
                {field?.type && (
                  <>
                    <label className="field-label">
                      {field?.label}
                      {field.optional && (
                        <span className="optional">(optional)</span>
                      )}
                    </label>
                    {field?.tooltip && (
                      <>
                        {/* <SVGIcon
                          icon={"info-fill"}
                          className="m-0 ps-1 fontCircleInfo"
                          data-tip
                          data-for={field?.key}
                        /> */}
                        {/* <ReactTooltip id={field?.key} place="top">
                      {field?.tip}
                    </ReactTooltip> */}
                      </>
                    )}
                  </>
                )}
                {field?.type && field?.type === "input" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <Input
                        placeholder={field?.placeholder}
                        disabled={field?.disabled}
                      // validateStatus={validateEmptyField(name) ? 'success' : 'error'}
                      />
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "button" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <Button
                        className="submit-btn"
                        type={field?.variant}
                        htmlType={field?.submit ? "submit" : "button"}
                        onClick={() => { onFinish({ key: field?.key }) }}
                        disabled={field?.disabled}
                      >{field?.title}</Button>
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "select" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <Select
                        placeholder={field?.placeholder}
                        onChange={(e) => onSelectChange(e, field)}
                        showSearch
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        options={field?.options}
                        disabled={field?.disabled}
                        maxTagCount={field?.maxTagCount}
                      ></Select>
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "multi-select" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <Select
                        placeholder={field?.placeholder}
                        optionFilterProp="label"
                        showSearch
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        mode="multiple"
                        showArrow={true}
                        options={field?.options}
                        disabled={field?.disabled}
                        maxTagCount={field?.maxTagCount}
                      ></Select>
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "date-picker" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <DatePicker
                        style={{ width: "100%" }}
                        format={field?.format}
                        placeholder={field?.placeholder}
                        onChange={(e) => onSelectChange(e, field)}
                      />
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "inputNumber" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder={field?.placeholder}
                        disabled={field?.disabled}
                      />
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "Select-Cascader" && (
                  <Form.Item name={field?.key} rules={field?.rules}>
                    <Cascader
                      style={{ width: "100%" }}
                      placeholder={field?.placeholder}
                      maxTagCount={field?.maxTagCount}
                      options={field?.options}
                      multiple={field?.type === "Select_Multi_Cascader"}
                      showSearch={true}
                    />
                  </Form.Item>
                )}
                {field?.type && field?.type === "tree-select" && (
                  <>
                    <Form.Item name={field?.key} rules={field?.rules}>
                      <TreeSelect
                        placeholder={field?.placeholder}
                        disabled={field?.disabled}
                        hideSelectedOptions={field?.hideSelectedOption}
                        showArrow
                        style={{ width: "100%" }}
                        treeData={field?.options}
                        treeCheckable={true}
                        allowClear={true}
                        labelInValue={true}
                        showSearch={true}
                        showCheckedStrategy={SHOW_CHILD}
                        menuPosition="fixed"
                        maxTagCount={field?.maxTagCount}
                        closeMenuOnSelect={field?.closeMenuSelect}
                      />
                    </Form.Item>
                  </>
                )}
                {field?.type && field?.type === "textArea" && (
                  <Form.Item name={field?.key} rules={field?.rules}>
                    <TextArea
                      rows={3}
                      maxLength={200}
                      placeholder={field?.placeholder}
                      disabled={field?.disabled}
                    />
                  </Form.Item>
                )}
                {field?.type && field?.type === "password" && (
                  <Form.Item name={field?.key} rules={field?.rules}>
                    <Input.Password
                      placeholder={field?.placeholder}
                      disabled={field?.disabled}
                      current-password=""
                    />
                  </Form.Item>
                )}
                {field?.type && field?.type === "checkbox" && (
                  <Form.Item name={field?.key} rules={field?.rules}>
                    <Checkbox.Group options={field?.options} />
                  </Form.Item>
                )}
                {field?.type && field?.type === "radio" && (
                  <Form.Item name={field?.key} rules={field?.rules}>
                    <Radio.Group>
                      {field?.options.map((option) => (
                        <Radio value={option?.value}>{option?.label}</Radio>
                      ))}
                    </Radio.Group>
                  </Form.Item>
                )}
                {/* {field?.type && field?.type === "file-upload" && (
                  <Form.Item name={field?.key} rules={field?.rules}>
                    <Upload action={'http://192.168.3.171:5000/api/v1.0/audit_lens/' + API_ENDPOINTS[field?.apiEndpoint]}
                      accept={field?.accept}
                      maxCount={field?.maxCount}
                      {...uploadProps}>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Form.Item>
                )} */}
              </Col>
            );
          })}
        </Row>
        )
      })}

      <Button className="submit-btn" type="primary" htmlType="submit"></Button>
    </Form>
  );
}
